import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { FormTextField } from 'components/common/form/Form';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { addQuoteSchema } from 'validation/form/marketplace';
import { useFileDrawers } from 'hooks/useFileDrawers';
import { useFile } from 'hooks/useFile';

export const EditQuoteSet = (props) => {
  const { close } = props;

  const { openDrawerFileDetails } = useFileDrawers();
  const { handleRenameQuote } = useFile();

  const fileFormLoading = useSelector((state) => state.files.fileForm.loading);
  const selectedFile = useSelector((state) => state.files.selectedFile);

  const methods = useForm({
    resolver: yupResolver(addQuoteSchema),
    defaultValues: selectedFile,
  });

  const handleSave = methods.handleSubmit((data) => {
    handleRenameQuote(data.oid, data.name, close);
  });

  const handleCancel = () => {
    openDrawerFileDetails();
  };

  useEffect(() => {
    if (selectedFile?.id) {
      methods.reset(selectedFile);
    }
  }, [selectedFile, methods]);

  return (
    <DrawerContent>
      <DrawerContent.Header title="Rename Quote" />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <FormProvider {...methods}>
            <FormTextField
              name="name"
              label="Quote Name"
              control={methods.control}
            />
          </FormProvider>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          submitButtonText="Save"
          submitButtonLoading={fileFormLoading}
          submit={handleSave}
          close={handleCancel}
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
